import React, { useContext, useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { ResultContext } from '../../contexts/ResultContext';
import { useTheme } from '../../contexts/ThemeContext';

const DuplicateClusterSizeHistogram = () => {

    const { theme } = useTheme();
    const isDark = theme === 'dark';
    const axisColor = isDark ? '#ccc' : '#333';

    const { result } = useContext(ResultContext);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const url = result?.results?.visualization_data_jsons['6_duplicate_cluster_sizes'];
        if (!url) return;

        const fetchData = async () => {
            try {
                const response = await fetch(url);
                if (!response.ok) throw new Error('Failed to fetch');
                const json = await response.json();
                const counts = json.map(item => item.Record_Count);
                setData(counts);
            } catch (error) {
                console.error('Error loading cluster size data:', error);
                setData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [result]);

    if (loading || data.length === 0) return <div>Loading chart...</div>;

    // Histogram binning
    const binCount = 20;
    const max = Math.max(...data);
    const binSize = Math.ceil(max / binCount);
    const bins = new Array(binCount).fill(0);

    data.forEach(count => {
        const index = Math.min(Math.floor(count / binSize), binCount - 1);
        bins[index]++;
    });

    const xLabels = bins.map((_, i) => {
        const start = i * binSize;
        const end = start + binSize - 1;
        return `${start}-${end}`;
    });

    const option = {
        title: {
            text: 'Distribution of Duplicate Cluster Sizes (Original)',
            left: 'center',
            textStyle: { color: axisColor },
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' },
            formatter: ({ 0: { name, value } }) => `Cluster Size: ${name}<br/>Count: ${value}`,
        },
        xAxis: {
            type: 'category',
            data: xLabels,
            name: 'Number of Records in Cluster',
            nameTextStyle: {
                color: axisColor
            },
            axisLabel: { rotate: 45, color: axisColor },
        },
        yAxis: {
            type: 'value',
            name: 'Count',
            axisLabel: { color: axisColor },
            nameTextStyle: {
                color: axisColor
            }
        },
        grid: {
            left: '2%',
            right: '10%',
            bottom: '15%',
            top: '15%',
            containLabel: true,
        },
        series: [
            {
                type: 'bar',
                data: bins,
                itemStyle: {
                    color: '#6366f1', // Indigo-500
                },
            },
        ],
    };

    return (
        <div className="border-2 border-gray-300 rounded-lg p-4 shadow mt-10">
            <ReactECharts option={option} style={{ height: 400 }} />
        </div>
    );
};

export default DuplicateClusterSizeHistogram;
